import axios from './axios'
import { PortalRoleType } from '@/enums/portal/portalRoleType'

export interface User {
  _id: string
  email: string
  firstName: string
  lastName: string
  role: string
  companyId: string
  nmls?: string
  company?: string
  phone?: string
  street?: string
  unit?: string
  city?: string
  avatar?: string
  state?: string
  zip?: string
  isActive: boolean
  accessLevel?: string
  hasFundedLoanAccess?: boolean
  hasMultipleCompanyAccess?: boolean
  isSupervisor?: boolean
  isProcessor?: boolean
  isLoanOfficer?: boolean
  tpoPortalRole?: string
  roles?: string[]
  isImpersonated?: boolean
  impersonatedBy?: string
}

export interface CreateUserData {
  email: string
  firstName: string
  lastName: string
  role: string
  companyId: string
  nmls?: string
  phone?: string
  street?: string
  unit?: string
  city?: string
  state?: string
  zip?: string
}

export interface UpdateUserData {
  firstName?: string
  lastName?: string
  role?: string
  nmls?: string
  phone?: string
  street?: string
  unit?: string
  city?: string
  state?: string
  zip?: string
}

class UserService {
  async getUsers(params?: { page?: number; limit?: number; companyId?: string; role?: string }) {
    const response = await axios.get('/users', { 
      params,
      withCredentials: true,
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    })
    return response.data
  }

  async getUser(id: string) {
    const response = await axios.get(`/users/${id}`, {
      withCredentials: true,
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    })
    return response.data
  }

  async createUser(data: CreateUserData) {
    const response = await axios.post('/users', data, {
      withCredentials: true,
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    })
    return response.data
  }

  async updateUser(id: string, data: UpdateUserData) {
    const response = await axios.put(`/users/${id}`, data, {
      withCredentials: true,
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    })
    return response.data
  }

  async deleteUser(id: string) {
    const response = await axios.delete(`/users/${id}`, {
      withCredentials: true,
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    })
    return response.data
  }

  async updateUserStatus(id: string, isActive: boolean) {
    const response = await axios.put(`/users/${id}/status`, { isActive }, {
      withCredentials: true,
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    })
    return response.data
  }

  async switchPortalRole(id: string, role: PortalRoleType) {
    const response = await axios.put(`/users/${id}/switch-portal-role`, { role }, {
      withCredentials: true,
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    })
    return response.data
  }

  async getUserPortalRole(id: string) {
    const response = await axios.get(`/users/${id}/portal-role`, {
      withCredentials: true,
      headers: {
        'Accept': 'application/json'
      }
    })
    return response.data
  }
}

export default new UserService()
